import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ReporteClientesInactivosPage } from '../reporte-clientes-inactivos/reporte-clientes-inactivos';
import { ReportePagosPage } from '../reporte-pagos/reporte-pagos';
import { ReportePedidosPage } from '../reporte-pedidos/reporte-pedidos';
import { ReporteResumenPage } from '../reporte-resumen/reporte-resumen';

/**
 * Generated class for the ReportesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reportes',
  templateUrl: 'reportes.html',
})
export class ReportesPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }

  irPantalla(item) {
    if (item === "RP") {
      this.navCtrl.push(ReportePedidosPage)
    }
    if (item === "RR") {
      this.navCtrl.push(ReporteResumenPage)
    }
    if (item === "RC") {
      this.navCtrl.push(ReporteClientesInactivosPage)
    }
    if (item === "RPG") {
      this.navCtrl.push(ReportePagosPage)
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/reportes/reportes.ts